
import React from 'react'
import SettingsMetaData from '../../../../../Components/Hooks/useSettingsMetaData'

function UnitEquipment() {
  return (
    <SettingsMetaData propertyName={"UnitEquipment"} viewPropertyName={"Unit"} />

  )
}

export default UnitEquipment
